<div class="button-container">
  <div class="button-container__inner">
    <c11n-button [labelText]="content.buttons.backButton" (clickEvent)="onBack()"
        variant="secondary" size="medium"></c11n-button>
    <c11n-button [labelText]="continueLabel" (clickEvent)="onContinue()"
        size="medium"></c11n-button>
  </div>
</div>